import axios from "axios";
export function careerListFilterButtonScript() {
    document.addEventListener( 'DOMContentLoaded', function () {
        let careerListFilterButton = document.querySelectorAll('.careerList__filterButton');
        let modalCareerOnPage = document.getElementById('modal');
        let modalClose = document.querySelectorAll('.modal__close');
        let termsModal = document.querySelectorAll('.modal__content__buttons .singleTerms');
        let indexFindPost = document.querySelector('.modal__footer .modal__count');
        let modal__showPost = document.getElementById('modal__showPost');
        let careerListSearchForm =document.getElementById('careerList__search')
        careerListFilterButton.forEach((singlebutton)=>{
          singlebutton.addEventListener('click',modalEvent);
        })
        function modalEvent(){
          if( modalCareerOnPage.classList.contains('active')){
            modalCareerOnPage.classList.remove('active');
          }else{
            modalCareerOnPage.classList.add('active');
          }
        }
        modalClose.forEach((e)=>{
          e.addEventListener('click', closeModal);
        })
        function closeModal(){
          modalCareerOnPage.classList.remove('active');
        }
        termsModal.forEach((singleTerms)=>{
          singleTerms.addEventListener('click',()=>{
            let currentInput = singleTerms.querySelector('input:checked');
            if(currentInput){
              singleTerms.classList.add('active');
            }else{
              singleTerms.classList.remove('active');
            }
            getCountOffer();
          })
        })
        function getDataForm(){
          let dataForm = new Object();
          termsModal.forEach((singleTerms)=>{
              let currentInput = singleTerms.querySelector('input:checked');
              if(currentInput){
                let singleTermID = currentInput.getAttribute('data-name')
                let currentValue = [currentInput.value];
                if( !dataForm[singleTermID]){
                  dataForm[singleTermID] = currentValue;
                }else{
                  dataForm[singleTermID] = [...dataForm[singleTermID] , ...currentValue];
                }
                
              }           
          });
          return  JSON.stringify( dataForm);
        }
        function getCountOffer(){
          let currentData  = getDataForm();
          let form_data = new FormData();
          form_data.append('nonce', ajax.nonce);
          form_data.append('data', currentData );
          form_data.append("action", "career_count");
          axios
          .post(
          ajax.url,
          form_data
          )
          .then((response) => {
              if (response.data.status == 'succes'){
                  indexFindPost.textContent = "(" + response.data.count + ")"; 
              }
          });
      }
      modal__showPost.addEventListener('click',()=>{
        careerListSearchForm.submit();
      })
    })
}
